import React from "react";
import { RiSafe2Line } from "react-icons/ri";
import { HiPlus } from "react-icons/hi";
import { CustomButton } from "./CustomButton";

interface SpaceEmptyStateProps {
  title: string;
  subtitle: string;
  actionLabel?: string;
  onAction?: () => void;
  icon?: React.ReactNode;
}

export const SpaceEmptyState: React.FC<SpaceEmptyStateProps> = ({
  title,
  subtitle,
  actionLabel,
  onAction,
  icon,
}) => {
  return (
    <div className="rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 p-10 text-center sm:p-12">
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-16 w-16 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-400">
          {icon ?? <RiSafe2Line className="h-8 w-8" />}
        </div>
        <div className="max-w-md">
          <h3 className="mb-1 text-lg font-semibold text-gray-700">{title}</h3>
          <p className="text-sm text-gray-500">{subtitle}</p>
        </div>
        {actionLabel && onAction && (
          <CustomButton
            variant="primary"
            onClick={onAction}
            icon={<HiPlus className="h-4 w-4" />}
            title={actionLabel}
            className="mt-2"
          />
        )}
      </div>
    </div>
  );
};

export default SpaceEmptyState;
